import CodeIcon from '@material-ui/icons/Code';
import { HomeEmptyState } from '../atoms/HomeEmptyState';
import { HomeWorkItem } from '../molecules/HomeWorkItem';
import { HomeWorkQueue } from './HomeWorkQueue';
import { useHomePullRequests } from '../../hooks/useHomePullRequests';
import { formatHomeDate } from '../../homeUtils';
import type { HomeUser } from '../../homeTypes';

interface HomePullRequestsProps {
  backendUrl: string;
  githubUsername?: string;
  githubSyncInProgress: boolean;
  refreshIdentity: () => Promise<HomeUser>;
}

export const HomePullRequests = ({
  backendUrl,
  githubUsername,
  githubSyncInProgress,
  refreshIdentity,
}: HomePullRequestsProps) => {
  const { pullRequests, loading, error, refresh } = useHomePullRequests(
    backendUrl,
    githubUsername,
    refreshIdentity,
  );

  return (
    <HomeWorkQueue
      title="Mis Pull Requests Abiertos"
      count={!!pullRequests.length ? pullRequests.length : undefined}
      icon={<CodeIcon />}
      href="/pull-requests"
      onRefresh={refresh}
      refreshLabel="Actualizar pull requests"
      loading={loading}
      loadingLabel="Cargando pull requests"
      error={error}
      hasItems={pullRequests.length > 0}
      empty={
        githubSyncInProgress ? (
          <HomeEmptyState title="Sincronización en proceso">
            Estamos sincronizando tu usuario con GitHub. Por favor, haz clic en
            el botón de actualizar en unos segundos.
          </HomeEmptyState>
        ) : (
          <HomeEmptyState>
            No se encontraron pull requests recientes.
          </HomeEmptyState>
        )
      }
    >
      {pullRequests.map(pullRequest => (
        <HomeWorkItem
          key={pullRequest.id}
          href={pullRequest.url}
          title={`${pullRequest.repo}#${pullRequest.number}: ${pullRequest.title}`}
          status={pullRequest.state}
          active={pullRequest.state === 'open'}
          muted={pullRequest.state !== 'open'}
          metadata={`Actualizado ${formatHomeDate(pullRequest.updatedAt)}`}
        />
      ))}
    </HomeWorkQueue>
  );
};
